import { render, staticRenderFns } from "./PaymentSetup.vue?vue&type=template&id=6462ab04&scoped=true&"
import script from "./PaymentSetup.vue?vue&type=script&lang=js&"
export * from "./PaymentSetup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSetup.vue?vue&type=style&index=0&id=6462ab04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462ab04",
  null
  
)

export default component.exports